import { useState, useEffect, SetStateAction } from 'react';

/**
 * useDebouncedState
 * @param initialValue - initial value
 * @param delay - delay in milliseconds
 * @returns [debouncedValue, setValue]
 */
export const useDebouncedState = <T>(initialValue: T, delay: number): [T, (value: SetStateAction<T>) => void] => {
  const [value, setValue] = useState<T>(initialValue);
  const [debouncedValue, setDebouncedValue] = useState<T>(initialValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return [debouncedValue, setValue];
};
